import { render, staticRenderFns } from "./DemoLogin.vue?vue&type=template&id=5bd0cbf2&scoped=true"
import script from "./DemoLogin.vue?vue&type=script&lang=js"
export * from "./DemoLogin.vue?vue&type=script&lang=js"
import style0 from "./DemoLogin.vue?vue&type=style&index=0&id=5bd0cbf2&prod&scoped=true&lang=css"
import style1 from "./DemoLogin.vue?vue&type=style&index=1&id=5bd0cbf2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd0cbf2",
  null
  
)

export default component.exports